import { save, get } from '@/services/config/articleItemProcessingConfig';

export default {
  namespace: 'articleItemProcessingConfig',
  state: {
    data: [],
  },

  effects: {
    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
      if (response.success) {
        yield put({
          type: 'success',
          payload: response.data ? response.data : [],
        });
      }
    },
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
